const isProd = process.env.NODE_ENV === "production";

function getCallerInfo() {
  const oldStackTrace = Error.prepareStackTrace;
  Error.prepareStackTrace = (_, stack) => stack;
  const err = new Error();
  const stack = err.stack;
  Error.prepareStackTrace = oldStackTrace;
  console.log("StackTrade", stack);

  if (stack && stack.length > 2) {
    const caller = stack[2]; // Cambia el índice si no apunta bien
    return `${caller.getFileName()}:${caller.getLineNumber()}:${caller.getColumnNumber()}`;
  }
  return "Unknown location";
}

function cleanFilePath(filePath) {
  return filePath.replace(/^\.next\/(server|static)\/chunks\//, "/src/");
}

// const getCallerInfo = () => {
//   try {
//     const err = new Error();
//     const stackLines = err.stack.split("\n");
//     // La línea 3 del stack suele ser la llamada real (ajustar si necesario)
//     console.log("stackLines",stackLines);
//     const callerLine = stackLines[3] || stackLines[2]; // Ajuste para navegadores diferentes
//     return callerLine.trim();
//   } catch (e) {
//     return "[UNKNOWN LOCATION]";
//   }
// }

function shouldLog() {
  if (!isProd) return true; // Siempre mostrar logs en dev
  if (typeof window !== "undefined") {
    const params = new URLSearchParams(window.location.search);
    return params.get("debugmode") === "on"; // Mostrar logs si ?debugmode=on en la URL
  }

  return false;
}

export const logger = {
  log: (...args) => shouldLog() && console.log("[LOG]:", ...args), //, getCallerInfo()),
  warn: (...args) => shouldLog() && console.warn("[WARN]:", ...args), //, getCallerInfo()),
  error: (...args) => shouldLog() && console.error("[ERROR]:", ...args), //, getCallerInfo()),
  table: (...args) => shouldLog() && console.table(...args),
  logServer: (...args) => shouldLog() && typeof window === "undefined" && console.log("[SERVER]:", ...args),
};

